// constants.js
export const UPLOADS_DIRECTORY = '/path/to/uploads'; //пример

//для работы по сети
export const baseUrlApi = "https://api.info.cpc.tomsk.ru";
//для работы на локальном сервере 
// export const baseUrlApi = "http://localhost:5000";